import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export function useScrollToTop() {
  const router = useHistory();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [router.location.pathname]);
}
